//import axios from 'axios'
import api from './axiosConfig'

export const customerApi = {

    searchCustomers({ search, page, perPage } = {}) {
        return api
            .get('/customer/search?search=' + search + '&page=' + page + '&perPage=' + perPage)
            .then((response) => {
                return response.data
            })
    },
	
    createCustomer({ name, document, corporateName, tradeName, note, alertEmail, techEmail, techManager, techPhone } = {}) {
        return api
            .post('/customer/createcustomer', { name, document, corporateName, tradeName, note, alertEmail, techEmail, techManager, techPhone }, {})
            .then((response) => {
                return response.data
            })
    },
	
    updateCustomer({ id, name, document, corporateName, tradeName, note, alertEmail, techEmail, techManager, techPhone } = {}) {
        return api
            .put('/customer/update', { id, name, document, corporateName, tradeName, note, alertEmail, techEmail, techManager, techPhone }, {})
            .then((response) => {
                return response.data
            })
    }, 		
	
    getCustomer({ id } = {}) {
        return api
            .get('/customer?id=' + id)
            .then((response) => {
                return response.data
            })
    },	
}
